class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.autoCloseTimer = null;
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#ajaxcart-overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.setAjaxCartFormHandling();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#ajax-cart-icon");
    if (!cartLink) return;
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  setAjaxCartFormHandling() {
    document.addEventListener("submit", (event) => {
      const form = event.target;
      if (!form || form.closest("cart-action")) return;
      const action = form.getAttribute("action") || "";
      if (!action.includes("/cart/add")) return;

      event.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      submitButton?.classList.add("loading");
      submitButton?.setAttribute("aria-disabled", "true");

      const formData = new FormData(form);
      formData.append(
        "sections",
        this.fetchSecToInclude().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.setActiveElement(document.activeElement);
      const config = stFetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      config.body = formData;

      fetch(`${routes.increase_cart_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            window.location = window.routes.cart_url;
            return;
          }
          this.classList.remove("is-empty");
          this.renderContents(response);
        })
        .catch(() => {
          window.location = window.routes.cart_url;
        })
        .finally(() => {
          submitButton?.classList.remove("loading");
          submitButton?.removeAttribute("aria-disabled");
        });
    });
  }
  open(triggeredBy, autoClose = false) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    this.clearAutoClose();
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      if (autoClose) this.startAutoClose();
    });
    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".cart-inner-empty")
          : document.getElementById("ajaxcart");
        const focusElement = this.querySelector(".drawer-inner");
        triggerClick(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }
  close() {
    this.clearAutoClose();
    this.classList.remove("active");
    triggerClickClose(this.activeElement);
  }
  startAutoClose() {
    this.clearAutoClose();
    this.autoCloseTimer = setTimeout(() => {
      this.close();
    }, 20000);
  }
  clearAutoClose() {
    if (!this.autoCloseTimer) return;
    clearTimeout(this.autoCloseTimer);
    this.autoCloseTimer = null;
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }
    cartDrawerNote.parentElement.addEventListener("keyup", escClick);
  }
  renderContents(parsedState) {
    this.querySelector(".drawer-inner").classList.contains("is-empty") &&
      this.querySelector(".drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.fetchSecToInclude().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.callSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    setTimeout(() => {
      this.querySelector("#ajaxcart-overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open(null, true);
    });
  }
  callSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  fetchSecToInclude() {
    return [
      {
        id: "ajax-cart",
        selector: "#ajaxcart",
      },
      {
        id: "ajax-cart-icon",
      },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("ajax-cart", ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: "ajaxcart",
        section: "ajax-cart",
        selector: ".drawer-inner",
      },
      {
        id: "ajax-cart-icon",
        section: "ajax-cart-icon",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-pro", ajaxCartPro);
